export const GlobalVariables = {
  affiliateCodes: ["launch"],
  domains: {
    api: {
      prod: "https://api.jobtest.org",
      staging: "https://stagapi.jobtest.org",
      dev: "https://devapi.jobtest.org", // Not used
      local: "http://localhost:3000"
    },
    app: {
      prod: "app.jobtest.org",
      staging: "stagingapp.jobtest.org",
      local: "localhost:5173"
    },
    website: {
      prod: "jobtest.org",
      staging: "jobtestorg.webflow.io",
      local: "localhost:8080"
    }
  },
  careerAcceleratorResourcesLink: "https://sites.google.com/jobtest.org/careeraccelerator/home",
  postSessionStripeLinks: {
    prod: {
      scopingSession: "https://buy.stripe.com/14kg2v9qT4dTf2E15k",
      biWeeeklySubscription: "https://buy.stripe.com/aEU3fJ0Unh0FbQs5lB",
      weeklySubscription: "https://buy.stripe.com/fZedUnfPhfWB2fS6pG"
    },
    staging: {
      scopingSession: "https://checkout.jobtest.org/b/test_7sI00k90P5YW95m3co",
      biWeeeklySubscription: "https://checkout.jobtest.org/b/test_cN2cN66SHfzw3L2bIV",
      weeklySubscription: "https://checkout.jobtest.org/b/test_28obJ25OD3QOa9q5ky"
    }
  },
  qublQuizIds: {
    prod: {
      jobTest: "43ef9eaf-3cb6-41cd-9b5f-6a5cb8d17fcf", // Report Flow - v6.2
      jobQuiz: "e65e39e0-a5b2-4a96-b65d-50ace7267c86", // Report Flow - v6.0 OAUTH
      testRetake: "3126fdaf-08ce-4eb3-a5cb-7c62eb1659f1", // Report Flow - v6.0
      coaching: "e3de1d34-7d1e-49be-895b-65347ec7a11f" // Coaching Quiz
    },
    staging: {
      jobTest: "43ef9eaf-3cb6-41cd-9b5f-6a5cb8d17fcf", // Report Flow - v6.2
      jobQuiz: "e65e39e0-a5b2-4a96-b65d-50ace7267c86", // Report Flow - v6.0 OAUTH
      testRetake: "3126fdaf-08ce-4eb3-a5cb-7c62eb1659f1", // Report Flow - v6.0
      coaching: "e3de1d34-7d1e-49be-895b-65347ec7a11f" // Coaching Quiz
    }
  },
  qublQuizStyles: {
    jobTest: "styles/qubl.css",
    jobQuiz: "styles/qubl.css",
    testRetake: "styles/qubl.css"
  },
  userSourceKeys: [
    "adposition",
    "campaignid",
    "ttclid",
    "fbclid",
    "gclid",
    "keyword",
    "landing_page",
    "subId1",
    "utm_campaign",
    "utm_content",
    "utm_medium",
    "utm_source",
    "utm_term"
  ],
  urls: {
    root: {
      path: "/",
      routeName: "root"
    },
    auth: {
      path: "/auth",
      routeName: "auth",
      children: {
        magic: {
          path: "/magic",
          routeName: "magic",
          routeTitle: "Magic Link Verification"
        }
      }
    },
    login: {
      path: "/login",
      routeName: "login"
    },
    logout: {
      path: "/logout",
      routeName: "logout"
    },
    register: {
      path: "/register",
      routeName: "register"
    },
    firstStep: {
      path: "/first-step",
      routeName: "firstStep"
    },
    error: {
      path: "/error",
      routeName: "error"
    },
    thankYou: {
      path: "/thank-you",
      routeName: "thankYou"
    },
    confirmation: {
      path: "/confirmation",
      routeName: "generalConfirmation"
    },
    jobQuiz: {
      path: "/job-quiz",
      routeName: "jobQuiz"
    },
    jobTest: {
      path: "/job-test",
      routeName: "jobTest"
    },
    loading: {
      path: "/loading",
      routeName: "loading"
    },
    pleaseWait: {
      path: "/please-wait",
      routeName: "pleaseWait"
    },
    processing: {
      path: "/processing",
      routeName: "processing"
    },
    begin: {
      path: "/begin",
      routeName: "begin"
    },
    discover: {
      path: "/discover",
      routeName: "discover"
    },
    getStarted: {
      path: "/get-started",
      routeName: "getStarted"
    },
    welcome: {
      path: "/welcome",
      routeName: "welcome"
    },
    hello: {
      path: "/hello",
      routeName: "hello"
    },
    start: {
      path: "/start",
      routeName: "start"
    },
    resume: {
      path: "/resume",
      routeName: "resume",
      children: {
        confirmation: {
          path: "/confirmation",
          routeName: "resumeConfirmation",
          routeTitle: "Confirmation"
        }
      }
    },
    resumeBuilder: {
      path: "/resume-builder",
      routeName: "resumeBuilder",
      children: {
        confirmation: {
          path: "/confirmation",
          routeName: "resumeBuilderConfirmation",
          routeTitle: "Confirmation"
        }
      }
    },
    coaching: {
      path: "/coaching",
      routeName: "coaching",
      children: {
        home: {
          path: "/home",
          routeName: "coachingHome",
          routeTitle: "Home"
        },
        meetingNotes: {
          path: "/meeting-notes",
          routeName: "meetingNotes",
          routeTitle: "Meeting Notes"
        },
        quiz: {
          path: "/quiz",
          routeName: "coachingQuiz",
          routeTitle: "Quiz"
        },
        questionnaire: {
          path: "/questionnaire",
          routeName: "coachingQuestionnaire",
          routeTitle: "Coaching Questionnaire"
        },
        lifecycle: {
          path: "/v",
          routeName: "coachingLifecycle"
        },
        loading: {
          path: "/loading",
          routeName: "coachingLoading"
        },
        confirmation: {
          path: "/confirmation",
          routeName: "coachingConfirmation",
          routeTitle: "Confirmation"
        },
        confirmed: {
          path: "/confirmed",
          routeName: "coachingConfirmed",
          routeTitle: "Confirmed"
        },
        thankYou: {
          path: "/thank-you",
          routeName: "coachingThankYou",
          routeTitle: "Thank You"
        },
        chooseCoach: {
          path: "/choose-coach",
          routeName: "chooseCoach",
          routeTitle: "Choose Coach"
        },
        selectCoach: {
          path: "/select-coach",
          routeName: "selectCoach",
          routeTitle: "Select Coach"
        },
        selectTime: {
          path: "/select-time"
        },
        choosePlan: {
          path: "/choose-plan",
          routeName: "choosePlan",
          routeTitle: "Choose Plan"
        },
        cart: {
          path: "/cart",
          routeName: "cart",
          routeTitle: "Cart"
        },
        selectPlan: {
          path: "/select-plan",
          routeName: "selectPlan",
          routeTitle: "Select Plan"
        },
        coachingBundle: {
          path: "/bundle",
          routeName: "coachingBundle",
          routeTitle: "Coaching Bundle"
        }
      }
    },
    report: {
      path: "/report",
      routeName: "report",
      children: {
        welcome: {
          path: "/welcome"
        },
        home: {
          path: "/home",
          routeName: "reportHome",
          routeTitle: "Home"
        },
        account: {
          path: "/account",
          routeName: "reportAccount",
          routeTitle: "Account"
        },
        personality: {
          path: "/personality",
          routeName: "reportPersonality",
          routeTitle: "Personality"
        },
        careersOverview: {
          path: "/careers",
          routeName: "reportCareersOverview",
          routeTitle: "Careers"
        },
        careers: {
          path: "/careers",
          routeName: "reportCareers",
          routeTitle: "Careers"
        },
        confirmation: {
          path: "/confirmation",
          routeName: "reportConfirmation",
          routeTitle: "Confirmation"
        },
        groupCoaching: {
          path: "/group-coaching",
          routeName: "reportGroupCoaching",
          routeTitle: "Group Coaching"
        },
        newCareers: {
          path: "/get-new-careers",
          routeName: "reportNewCareers",
          routeTitle: "Get New Careers"
        },
        resources: {
          path: "/resources",
          routeName: "reportResources",
          routeTitle: "Resources"
        },
        resumeBuilder: {
          path: "/resume-builder",
          routeName: "reportResumeBuilder",
          routeTitle: "Job Ready Resume Builder"
        },
        coachingUpsell: {
          path: "/career-coach",
          routeName: "reportCoachingUpsell",
          routeTitle: "Meet your Personalized Coach"
        },
        coachingUpsellB: {
          path: "/personalized-coach",
          routeName: "reportCoachingUpsellB",
          routeTitle: "Meet your Personalized Coach"
        },
        selectCoach: {
          path: "/select-coach"
        },
        testRetake: {
          path: "/test-retake",
          routeName: "testTetake",
          routeTitle: "Test Retake"
        },
        testAdjustment: {
          path: "/test-adjustment",
          routeName: "testAdjustment",
          routeTitle: "Test Adjustment"
        },
        checkout: {
          path: "/checkout",
          routeName: "reportCheckout",
          routeTitle: "Checkout"
        },
        outdated: {
          path: "/outdated",
          routeName: "reportOutdated",
          routeTitle: "Outdated"
        },
        feedback: {
          path: "/feedback",
          routeName: "reportFeedback",
          routeTitle: "Feedback"
        }
      }
    },
    website: {
      path: "https://www.jobtest.org"
    }
  },
  urlQueryKeys: {
    fullName: "fullName",
    zipCode: "zipCode"
  },
  zigpollId: "6408cf4a7efd2f0bec58e07c",
  zigpolls: {
    finishedCoaching: "66ba5a7e5bbae26d9124cc28",
    finishedReport: "65b54a540a08b10c2839d1dd",
    freeUpgradeEligible: "66175c4b2686e3bd7020bcc2",
    freeReport: "654a58c7662b850c1ce7f6d3",
    paidReport: "654a58a0662b850c1ce7f6c6"
  }
}
